import { c as _c } from "react/compiler-runtime";
import useTranslation from '@/hooks/useTranslation';
import classNames from '@/utils/classNames';
import type { HTMLAttributes } from 'react';
import { useEffect, useState } from 'react';
import styles from './LiveCountdown.module.css';
interface IProps extends HTMLAttributes<HTMLParagraphElement> {
  /** Date ISO String */
  to: string;
}
const calculateMillisecondsLeft = (to: Date) => {
  const ms = to.getTime() - Date.now();
  return Math.max(0, ms);
};
const millisecondsToString = (ms: number) => {
  const seconds = Math.floor(Math.abs(ms) / 1000);
  const mins = Math.floor(seconds / 60);
  return `${mins.toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
};

/** Counts down to a time in minutes and seconds. Stops at 0 */
export const LiveCountdown = t0 => {
  const $ = _c(19);
  let className;
  let props;
  let to;
  if ($[0] !== t0) {
    ({
      to,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = to;
  } else {
    className = $[1];
    props = $[2];
    to = $[3];
  }
  const {
    t
  } = useTranslation();
  const [msLeft, setMillisecondsLeft] = useState();
  let t1;
  if ($[4] !== to) {
    t1 = new Date(to);
    $[4] = to;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const toDate = t1;
  let t2;
  let t3;
  if ($[6] !== msLeft || $[7] !== toDate) {
    t2 = () => {
      if (msLeft <= 0) {
        return;
      }
      const timer = setInterval(() => {
        setMillisecondsLeft(calculateMillisecondsLeft(toDate));
      }, 1000);
      return () => clearInterval(timer);
    };
    t3 = [msLeft, toDate, setMillisecondsLeft];
    $[6] = msLeft;
    $[7] = toDate;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== className) {
    t4 = classNames(styles.textContainer, className);
    $[10] = className;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== msLeft || $[13] !== t) {
    t5 = msLeft && t("LiveCountdown.liveIn", {
      time: millisecondsToString(msLeft)
    });
    $[12] = msLeft;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== props || $[16] !== t4 || $[17] !== t5) {
    t6 = <p className={t4} {...props}>{t5}</p>;
    $[15] = props;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};